export const updateArray = <T>(arr: T[], i: number, value: T) =>
  Object.assign([...arr], {[i]: value})

export const removeFromArray = <T>(arr: T[], indexToRemove: number) =>
  arr.filter((_, i) => i !== indexToRemove)

export const omit = <T extends object, K extends string>(
  obj: T,
  keyToRemove: K | K[]
): Omit<T, K> => {
  const remove = typeof keyToRemove === 'string' ? [keyToRemove] : keyToRemove
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !remove.includes(key as K))
  ) as Omit<T, K>
}

// pick attributes with keys from obj
export const pick = <T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  keys: K[]
): Pick<T, K> =>
  Object.fromEntries(
    keys
      .filter(key => key in obj) // ignore missing keys
      .map(key => [key, obj[key]])
  ) as Pick<T, K>

export const insertIntoArray = <T>(arr: T[], i: number, value: T) => [
  ...arr.slice(0, i),
  value,
  ...arr.slice(i)
]

export const replaceAt = <T>(
  array: readonly T[],
  index: number,
  value: T
): T[] => {
  return array.map((item, i) => (i === index ? value : item))
}
